import { Injectable } from '@angular/core';
import { FieldAssessmentCheckListModel, FieldAssessmentCheckListBySectionModel } from 'src/app/models/field-assessment-checklist.model';
import { PreFieldChecklistInterface } from './pre-field-checklist.service.interface';

@Injectable({
  providedIn: 'root'
})
export class PreFieldChecklistService implements PreFieldChecklistInterface{

  fieldAssessmentChecklistBySection: FieldAssessmentCheckListBySectionModel[] = [];
  
  constructor() { }
}
